import { HttpMethod, PaginatedResponse, Type } from "@/Utils/request/types";

import {
  MVPFacilityScopedRecord,
  MVPModuleConfiguration,
  MVPModuleConfigurationWrite,
} from "./operations";

export default {
  listModuleConfigurations: {
    path: "/api/v1/facility/{facilityId}/mvp/module_configurations/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<MVPModuleConfiguration>>(),
  },
  createModuleConfiguration: {
    path: "/api/v1/facility/{facilityId}/mvp/module_configurations/",
    method: HttpMethod.POST,
    TRes: Type<MVPModuleConfiguration>(),
    TBody: Type<MVPModuleConfigurationWrite>(),
  },
  updateModuleConfiguration: {
    path: "/api/v1/facility/{facilityId}/mvp/module_configurations/{configurationId}/",
    method: HttpMethod.PUT,
    TRes: Type<MVPModuleConfiguration>(),
    TBody: Type<MVPModuleConfigurationWrite>(),
  },
  listPharmacyStores: {
    path: "/api/v1/facility/{facilityId}/mvp/pharmacy/stores/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<MVPFacilityScopedRecord>>(),
  },
  listPharmacyDrugs: {
    path: "/api/v1/facility/{facilityId}/mvp/pharmacy/drugs/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<MVPFacilityScopedRecord>>(),
  },
  listLaboratoryTests: {
    path: "/api/v1/facility/{facilityId}/mvp/laboratory/tests/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<MVPFacilityScopedRecord>>(),
  },
  listEmergencyRegistrations: {
    path: "/api/v1/facility/{facilityId}/mvp/emergency/registrations/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<MVPFacilityScopedRecord>>(),
  },
  listEmergencyAssessments: {
    path: "/api/v1/facility/{facilityId}/mvp/emergency/assessments/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<MVPFacilityScopedRecord>>(),
  },
  listEmergencyBedAllocations: {
    path: "/api/v1/facility/{facilityId}/mvp/emergency/bed_allocations/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<MVPFacilityScopedRecord>>(),
  },
  listBillingPayments: {
    path: "/api/v1/facility/{facilityId}/billing/payments/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<MVPFacilityScopedRecord>>(),
  },
  listImagingStudies: {
    path: "/api/v1/facility/{facilityId}/imaging/studies/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<MVPFacilityScopedRecord>>(),
  },
} as const;
